import { render, staticRenderFns } from "./DialogProductGroup.vue?vue&type=template&id=0644db63&scoped=true&"
import script from "./DialogProductGroup.vue?vue&type=script&lang=js&"
export * from "./DialogProductGroup.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=0644db63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0644db63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0644db63')) {
      api.createRecord('0644db63', component.options)
    } else {
      api.reload('0644db63', component.options)
    }
    module.hot.accept("./DialogProductGroup.vue?vue&type=template&id=0644db63&scoped=true&", function () {
      api.rerender('0644db63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Products/DialogProductGroup.vue"
export default component.exports